import React from "react";
import { Skeleton } from "@common/skeleton";
import { Props } from "./types";
import styles from "./styles.scss";

function ElementLoader(_: Props) {
  return (
    <div className={styles.memberLoader}>
      <div className={styles.title}>
        <Skeleton />
        <Skeleton />
        <Skeleton />
      </div>
      <div className={styles.member}>
        <div>
          <Skeleton />
        </div>
        <div>
          <Skeleton />
        </div>
      </div>
    </div>
  );
}

export { ElementLoader };
